import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {L10nTranslationService} from 'angular-l10n';
import {catchError, map, switchMap} from 'rxjs/operators';

import {debug} from '../../../rxjs-operators';
import {ExternalLinksActionTypes, LoadExternalLinksAction, LoadExternalLinksFailAction, LoadExternalLinksSuccessAction} from '../actions/external-links';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {ExternalLink} from '../models/external-link';
import {SendBackResult} from '../models/send-back-result';
import {ExternalLinksService} from '../services/external-links.service';

import {BaseEffect} from './base.effect';

@Injectable()
export class ExternalLinksEffect extends BaseEffect {
  load$ = createEffect(
    () => {  return this.actions$.pipe(ofType(ExternalLinksActionTypes.LOAD),
                             debug('External Links load action received.'),
                             switchMap((action: LoadExternalLinksAction) => this.externalLinksService.getList(action.payload)
                                                                              .pipe(map((payload: SendBackResult<ArrayResponse<ExternalLink>>) =>
                                                                                          new LoadExternalLinksSuccessAction(payload.data.array)),
                                                                                    catchError((res: Response) => this.catchResponseError(res)))))});

  loadFail$ = createEffect(
    () => {  return this.actions$.pipe(ofType(ExternalLinksActionTypes.LOAD_FAIL),
                                 debug('A server error occurred while retrieving group roles list.'),
                                 map(() => error(this.translation.translate('GROUP_ROLES_LOAD_ERROR'), this.translation.translate('TOAST_ERROR_TITLE'))))});

  constructor(private actions$: Actions, translation: L10nTranslationService, private externalLinksService: ExternalLinksService, router: Router) {
    super(router, translation);
  }

  protected handleUnhandledError(response: Response): Action { return new LoadExternalLinksFailAction(response.status); }
}
